<div class="dialog-wrap">
  <div class="warning-icon-wrap">
    <span class="material-symbols-outlined warning-icon">warning</span>
  </div>
  <p>
    <span>{{"VERSION_WARNING.HEADING" | translate}}</span>
    <span class="bold-text">{{"VERSION_WARNING.UPDATE_FUNCTION" | translate}}</span>
    <span>{{"VERSION_WARNING.PLEASE_TEXT" | translate}}</span>
  </p>
  <p class="bold-text">
    <span>{{"VERSION_WARNING.HOW" | translate}}</span>
  </p>
  <p>
    <span class="bold-text">{{"VERSION_WARNING.WINDOWS" | translate}}</span>
    <span>{{"VERSION_WARNING.WINDOWS_TEXT" | translate}}</span>
  </p>
  <p>
    <span class="bold-text">{{"VERSION_WARNING.MAC" | translate}}</span>
    <span>{{"VERSION_WARNING.MAC_TEXT" | translate}}</span>
  </p>
  <p>
    <span class="bold-text">{{"VERSION_WARNING.IMPORTANT" | translate}}</span>
    <span>{{"VERSION_WARNING.ALWAYS_USE" | translate}}</span>
    <span class="bold-text">{{"VERSION_WARNING.INCOGNITO" | translate}}</span>
  </p>
</div>
